import { m } from 'framer-motion'
import { useCallback, useState } from 'react'

import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'

import Iconify from '../../component/iconify'
import { varHover } from '../../utils/eventUtils'
import CustomPopover, { usePopover } from '../../component/custom-popover'
import { useTranslate } from '../../locales/use-locales'
import i18n from 'i18next'

// ----------------------------------------------------------------------

export const allLangs = [
    {
        label: 'Korean', // 한글 추가
        value: 'ko',
        icon: 'flagpack:kr',
    },
    {
        label: 'Japanese', // 일본어 추가
        value: 'ja',
        icon: 'flagpack:jp',
    },
]

export default function LanguagePopover() {
    const popover = usePopover()

    const { onChangeLang } = useTranslate()

    const [currentLang, setCurrentLang] = useState(allLangs.find((lang) => lang.value === i18n.language) || allLangs[0])

    const handleChangeLang = useCallback(
        (newLang) => {
            if (newLang !== currentLang.value) {
                // 언어 변경 함수 호출
                onChangeLang(newLang)
                // 선택한 언어로 상태 업데이트
                const selectedLang = allLangs.find((lang) => lang.value === newLang)
                setCurrentLang(selectedLang)
            }
            popover.onClose()
        },
        [onChangeLang, currentLang, popover],
    )

    return (
        <>
            <IconButton
                component={m.button}
                whileTap="tap"
                whileHover="hover"
                variants={varHover(1.05)}
                onClick={popover.onOpen}
                sx={{
                    width: 40,
                    height: 40,
                    ...(popover.open && {
                        bgcolor: 'action.selected',
                    }),
                }}
            >
                <Iconify icon={currentLang.icon} sx={{ borderRadius: 0.65, width: 28 }} />
            </IconButton>

            <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 160 }}>
                {allLangs.map((option) => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === currentLang.value}
                        onClick={() => {
                            handleChangeLang(option.value)
                        }}
                    >
                        <Iconify icon={option.icon} sx={{ borderRadius: 0.65, width: 28 }} />

                        {option.label}
                    </MenuItem>
                ))}
            </CustomPopover>
        </>
    )
}
